import { useQuery } from "@tanstack/react-query";

import { fetchClientDashboard } from "@/services/clientDashboard";
import type { ClientDashboard } from "@/types/clientDashboard";

import { useClientContextKey } from "./useClientContextKey";

interface UseClientDashboardReturn {
    dashboard: ClientDashboard | null;
    isLoading: boolean;
    error: Error | null;
}

export function useClientDashboard(): UseClientDashboardReturn {
    const contextKey = useClientContextKey();
    const { data, isLoading, error } = useQuery<ClientDashboard, Error>({
        queryKey: ["client-dashboard", contextKey],
        queryFn: fetchClientDashboard,
        staleTime: 5 * 60 * 1000
    });

    return {
        dashboard: data ?? null,
        isLoading,
        error
    };
}
